import {
    Box,
    TextField,
    FormControl,
    Autocomplete,
    IconButton,
    MenuItem,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import { CURRENCY_TO_COUNTRY } from '../../constants';

interface CurrencySearchProps {
    searchQuery: string;
    selectedCurrencies: string[];
    availableCurrencies: string[];
    onSearchChange: (query: string) => void;
    onAddCurrency: (currency: string) => void;
}

const CurrencySearch = ({
    searchQuery,
    selectedCurrencies,
    availableCurrencies,
    onSearchChange,
    onAddCurrency,
}: CurrencySearchProps) => {
    const { t } = useTranslation();
    const filteredCurrencies = availableCurrencies.filter(currency =>
        currency.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <Box sx={{ mb: 2 }}>
            <FormControl fullWidth>
                <Autocomplete
                    freeSolo
                    options={filteredCurrencies.filter(c => !selectedCurrencies.includes(c))}
                    inputValue={searchQuery}
                    onInputChange={(_, newValue) => onSearchChange(newValue)}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t('rates.searchCurrency')}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                        <IconButton
                                            onClick={() => searchQuery && onAddCurrency(searchQuery)}
                                            disabled={!searchQuery || selectedCurrencies.includes(searchQuery)}
                                        >
                                            <AddIcon />
                                        </IconButton>
                                    </>
                                )
                            }}
                        />
                    )}
                    renderOption={(props, option) => {
                        const info = CURRENCY_TO_COUNTRY[option];
                        return (
                            <MenuItem {...props} onClick={() => onAddCurrency(option)}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <span>{info.flag}</span>
                                    <span>{option}</span>
                                    <span style={{ color: 'text.secondary', marginLeft: 'auto' }}>
                                        {info.name}
                                    </span>
                                </Box>
                            </MenuItem>
                        );
                    }}
                />
            </FormControl>
        </Box>
    );
};

export default CurrencySearch; 